export const CURRENCY_TYPE_USD = 'USD'
export const CURRENCY_TYPE_CAD = 'CAD'
export const CURRENCY_SYMBOL_USD = '$'
export const CURRENCY_SYMBOL_CAD = 'C$'
